import styled from 'styled-components'

export const TableWrapper = styled.div` 
  padding: 5px 0px 0px 0px;
`
export const TabsWrapper = styled.div`
  margin-bottom: -32px;
`
